import React, { useState, useEffect } from 'react';
import { Table, Button, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../utils/api';

function ApiOpenLogs() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');

  const load = async (p = 1) => {
    try {
      const params = { page: p, pageSize: 50 }; if (keyword) params.keyword = keyword;
      const r = await api.get('/api-open/logs', { params });
      if (r.code === 200) { setData(r.data.list); setTotal(r.data.total); setPage(p); }
    } catch (e) {}
  };
  useEffect(() => { load(); }, []);

  const cols = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: 'Key名称', dataIndex: 'api_key_name', width: 120 },
    { title: '端点', dataIndex: 'endpoint', width: 220, ellipsis: true },
    { title: '方法', dataIndex: 'method', width: 60 },
    { title: '状态码', dataIndex: 'response_code', width: 70 },
    { title: '摘要', dataIndex: 'response_summary', width: 200, ellipsis: true },
    { title: 'IP', dataIndex: 'ip', width: 130 },
    { title: '时间', dataIndex: 'created_at', width: 160, render: v => v ? dayjs(v).format('MM-DD HH:mm:ss') : '-' }
  ];

  return (
    <div>
      <h3 style={{ margin: '0 0 16px 0' }}>调用日志</h3>
      <div style={{ marginBottom: 16, display: 'flex', gap: 8 }}>
        <Input prefix={<SearchOutlined />} placeholder="搜索Key名称或端点" value={keyword} onChange={e => setKeyword(e.target.value)} onPressEnter={() => load(1)} style={{ width: 300 }} allowClear />
        <Button type="primary" onClick={() => load(1)}>搜索</Button>
      </div>
      <Table rowKey="id" columns={cols} dataSource={data} pagination={{ current: page, pageSize: 50, total, onChange: load }} size="small" scroll={{ x: 1000 }} />
    </div>
  );
}

export default ApiOpenLogs;
